<div class="c-unsecured mb-30" *ngIf="unsecuredStatus?.isUnsecured">
  <div class="c-unsecured__left">
    <div class="c-unsecured__title">
      <p500-ui-icon name="secure-2" class="icon"></p500-ui-icon>
      <span i18n="@@common.unsecured_mode">Unsecured Mode</span>
    </div>
  </div>
  <div class="c-unsecured__right">
    <div #timer class="c-unsecured__time"></div>
    <div class="c-unsecured__separator"></div>
    <button
      p500-ui-confluent-button
      [transparent]="true"
      size="medium"
      color="warn"
      class="c-unsecured__button"
      [disabled]="isLoading"
      (click)="leaveMode()"
    >
      <span class="text" i18n="@@common.leave_mode">Leave Mode</span>
    </button>
  </div>
</div>
